import React from 'react';

import { type InlineSpan, parseDescription } from './utils/parseDescription';

const Spans: React.FC<{ spans: InlineSpan[] }> = ({ spans }) => (
  <>
    {spans.map((span, index) => {
      // Spans never reorder, so their position is a stable key.
      const key = `${span.kind}-${index}`;
      if (span.kind === 'bold') {
        return (
          <strong key={key} className="font-semibold text-default-600">
            {span.text}
          </strong>
        );
      }
      if (span.kind === 'code') {
        return (
          <code key={key} className="rounded bg-default-100 px-1 text-xs">
            {span.text}
          </code>
        );
      }
      return <React.Fragment key={key}>{span.text}</React.Fragment>;
    })}
  </>
);

/** A flag's description as written in the flag provider. */
export const FlagDescription: React.FC<{ description: string }> = ({
  description,
}) => (
  <div className="flex flex-col gap-1 text-sm text-default-500">
    {parseDescription(description).map((block, index) => {
      const key = `${block.kind}-${index}`;
      if (block.kind === 'list') {
        return (
          <ul key={key} className="list-disc pl-4">
            {block.items.map((item, itemIndex) => (
              <li key={`item-${itemIndex}`}>
                <Spans spans={item} />
              </li>
            ))}
          </ul>
        );
      }
      return (
        <p key={key}>
          <Spans spans={block.spans} />
        </p>
      );
    })}
  </div>
);
